import { Tour } from '../../types';

const isPartOfTour = (customPanoId: string, tour: Tour) => {
  return tour.streetViewTour.islands.some((island) =>
    island.scenes.some((scene) => scene._id === customPanoId)
  );
};

export default isPartOfTour;
